const TYPES = {
    INIT: 1,
    REFRESH: 2,
    PAGINATE: 3,
    UPDATE: 4,
    DELETE: 5,
};
export default TYPES;
